// @core/api/endpoints/workflow/revoke_pipeline_run_as_authorization.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PipelineRunAsRequestResponse,
  RevokePipelineRunAsAuthorizationRequest,
} from '../../../types/workflow';

const BASE_PATH = '/workflow';

/**
 * Revoke a pipeline-scoped execution identity approval
 * Performs revoke operation on pipeline run as authorization.
 */
export async function RevokePipelineRunAsAuthorization(
  request_id: string,
  data: RevokePipelineRunAsAuthorizationRequest,
  options?: RequestOptions
): Promise<PipelineRunAsRequestResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/run-as-requests/:request_id/revoke`;
  requestPath = requestPath.replace(':request_id', encodeURIComponent(request_id));
  const requestOptions = options;
  return client.post<PipelineRunAsRequestResponse>(requestPath, data, requestOptions);
}
